import { Row, Table, Modal, Space, Typography, Button, Input } from 'antd'
import { useRequest } from 'ahooks'
import React, { memo, useEffect, useMemo, useState } from 'react'
import classnames from 'classnames'
import { loadDimensions, deleteDimension } from '@/services/dimension/dimension.service'
import { Link } from 'react-router-dom'
import { Dimension } from '@/services/dimension/dimension.model'
import { PlusOutlined } from '@ant-design/icons'

const DimensionList = memo(() => {
  const [text, setText] = useState('')
  const { data: dimensions = [], refresh: dimensionsRefresh } = useRequest(loadDimensions)
  const filteredData = useMemo(() => {
    if (!text) {
      return dimensions
    }
    return dimensions.filter((item) => item.code.toLowerCase().includes(text))
  }, [dimensions, text])

  const toSearch = (e) => {
    const text = (e.target.value || '').toLowerCase()
    setText(text)
  }

  const columns = [
    { title: 'Index', dataIndex: '', render: (_, _record, index) => index + 1 },
    { title: 'Code', dataIndex: 'code' },
    { title: 'Description', dataIndex: 'description' },
    { title: 'Units', dataIndex: 'units', render: (units) => units.map((unit) => unit.code).join(', ') },
    {
      title: 'Action',
      dataIndex: '',
      render: (_, record: Dimension.Info) => (
        <Space>
          <Link to={String(record.id)}>Detail</Link>
          <a
            onClick={() => {
              Modal.confirm({
                content: 'Are you sure to delete?',
                onOk: async () => {
                  await deleteDimension(record.id)
                  dimensionsRefresh()
                }
              })
            }}
          >
            Delete
          </a>
        </Space>
      )
    }
  ]
  return (
    <div>
      <Typography.Title level={5}>Dimensions </Typography.Title>
      <Row justify={'space-between'}>
        <Input placeholder='Search' onChange={toSearch} style={{ width: 200 }} allowClear />
        <Link to={'create'}>
          <Button type='primary' icon={<PlusOutlined />}>
            Create
          </Button>
        </Link>
      </Row>

      <div className={classnames('mt-2')}>
        <Table bordered size='small' dataSource={filteredData} rowKey={(record) => record.id} columns={columns} />
      </div>
    </div>
  )
})

export default DimensionList
